import { useState } from 'react';

export default function Portfolio() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const projects = [
    {
      title: 'Modern Kitchen Renovation',
      location: 'Beverly Hills, CA',
      price: '$50K-$75K',
      sqft: '450 sq ft',
      timeline: '8 weeks',
      image: 'https://public.readdy.ai/ai/img_res/c09483312044ecdebc9ce30294ecc3d1.jpg'
    },
    {
      title: 'Luxury Master Bathroom',
      location: 'Santa Monica, CA',
      price: '$35K-$50K',
      sqft: '280 sq ft',
      timeline: '6 weeks',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20master%20bathroom%20with%20marble%20walls%2C%20freestanding%20soaking%20tub%2C%20frameless%20glass%20shower%2C%20double%20vanity%20with%20mirrors%2C%20elegant%20lighting%2C%20spa-like%20atmosphere%2C%20professional%20interior%20photography&width=500&height=700&seq=portfolio-bath-1&orientation=portrait'
    },
    {
      title: 'Open Concept Living Space',
      location: 'Malibu, CA',
      price: '$120K-$150K',
      sqft: '1200 sq ft',
      timeline: '12 weeks',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20open%20concept%20living%20room%20and%20dining%20area%20with%20vaulted%20ceilings%2C%20large%20windows%2C%20modern%20furniture%2C%20hardwood%20floors%2C%20contemporary%20design%2C%20natural%20light%2C%20professional%20architectural%20photography&width=500&height=700&seq=portfolio-living-1&orientation=portrait'
    },
    {
      title: 'Contemporary Basement Finish',
      location: 'Pasadena, CA',
      price: '$60K-$80K',
      sqft: '800 sq ft',
      timeline: '10 weeks',
      image: 'https://readdy.ai/api/search-image?query=modern%20finished%20basement%20with%20entertainment%20area%2C%20recessed%20lighting%2C%20luxury%20vinyl%20flooring%2C%20built-in%20shelving%2C%20contemporary%20furniture%2C%20cozy%20atmosphere%2C%20professional%20interior%20photography&width=500&height=700&seq=portfolio-basement-1&orientation=portrait'
    },
    {
      title: 'Elegant Powder Room',
      location: 'West Hollywood, CA',
      price: '$15K-$25K',
      sqft: '50 sq ft',
      timeline: '3 weeks',
      image: 'https://readdy.ai/api/search-image?query=elegant%20powder%20room%20with%20decorative%20wallpaper%2C%20modern%20vanity%2C%20vessel%20sink%2C%20statement%20mirror%2C%20ambient%20lighting%2C%20sophisticated%20design%2C%20professional%20interior%20photography&width=500&height=700&seq=portfolio-powder-1&orientation=portrait'
    },
    {
      title: 'Outdoor Living Expansion',
      location: 'Newport Beach, CA',
      price: '$90K-$110K',
      sqft: '600 sq ft',
      timeline: '14 weeks',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20outdoor%20living%20space%20with%20covered%20patio%2C%20outdoor%20kitchen%2C%20stone%20fireplace%2C%20comfortable%20seating%2C%20landscape%20lighting%2C%20modern%20design%2C%20professional%20architectural%20photography&width=500&height=700&seq=portfolio-outdoor-1&orientation=portrait'
    },
    {
      title: 'Home Office Conversion',
      location: 'Culver City, CA',
      price: '$25K-$35K',
      sqft: '200 sq ft',
      timeline: '5 weeks',
      image: 'https://readdy.ai/api/search-image?query=modern%20home%20office%20with%20built-in%20desk%2C%20custom%20shelving%2C%20large%20window%20with%20natural%20light%2C%20ergonomic%20furniture%2C%20contemporary%20design%2C%20professional%20workspace%2C%20interior%20photography&width=500&height=700&seq=portfolio-office-1&orientation=portrait'
    },
    {
      title: 'Gourmet Kitchen Upgrade',
      location: 'Manhattan Beach, CA',
      price: '$85K-$100K',
      sqft: '550 sq ft',
      timeline: '10 weeks',
      image: 'https://readdy.ai/api/search-image?query=gourmet%20kitchen%20with%20professional%20grade%20appliances%2C%20custom%20cabinetry%2C%20large%20island%20with%20seating%2C%20wine%20storage%2C%20pendant%20lighting%2C%20high-end%20finishes%2C%20professional%20interior%20photography&width=500&height=700&seq=portfolio-kitchen-2&orientation=portrait'
    }
  ];

  const itemsPerPage = 4;
  const maxIndex = Math.max(0, projects.length - itemsPerPage);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(maxIndex, prev + 1));
  };

  return (
    <section id="portfolio" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold text-gray-600 tracking-wider uppercase mb-3">OUR WORK</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Recent Transformations
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Explore our portfolio of stunning remodeling projects
          </p>
        </div>

        <div className="relative">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out gap-6"
              style={{ transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)` }}
            >
              {projects.map((project, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-full md:w-[calc(25%-18px)] cursor-pointer group"
                >
                  <div className="relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                    <div className="relative h-96 w-full">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute top-4 right-4 px-3 py-1.5 bg-white rounded-full shadow-md">
                        <span className="text-gray-900 text-xs font-semibold">{project.price}</span>
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                      <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                      <p className="text-sm text-white/90 mb-3">{project.location}</p>
                      <div className="flex items-center gap-4 text-xs">
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-ruler-line text-sm"></i>
                          </div>
                          <span>{project.sqft}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="w-4 h-4 flex items-center justify-center">
                            <i className="ri-time-line text-sm"></i>
                          </div>
                          <span>{project.timeline}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {currentIndex > 0 && (
            <button
              onClick={handlePrev}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer z-10"
            >
              <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
            </button>
          )}

          {currentIndex < maxIndex && (
            <button
              onClick={handleNext}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all cursor-pointer z-10"
            >
              <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
            </button>
          )}
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                index === currentIndex ? 'bg-gray-900 w-8' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
